export const OcdrCharity = {
    RAILWAY_CHILDREN: 'railway-children',
    DAME_KELLY_HOLMES_TRUST: 'DKHT',
    RSPCA: 'rspca',
    SAMARITANS: 'samaritans',
    CRUK: 'CRUK',
    GREAT_ORMOND_STREET: 'great-ormond-street',
    NHS: 'nhs',
    DEC: 'dec',
};

export const OcdrCharities = [
    {
        value: OcdrCharity.RAILWAY_CHILDREN,
        imageUrl: 'images/charity-railway-children.png',
        nameKey: 'charity.name.railway-children',
        descriptionKey: 'charity.description.railway-children',
        website: 'https://www.railwaychildren.org.uk/',
        linkText: 'www.railwaychildren.org.uk',
        featureFlagName: 'enableRailwayChildrenCharity',
    },
    {
        value: OcdrCharity.DAME_KELLY_HOLMES_TRUST,
        imageUrl: 'images/charity-dame-kelly.png',
        nameKey: 'charity.name.dame-kelly',
        descriptionKey: 'charity.description.dame-kelly',
        website: 'https://www.damekellyholmestrust.org/',
        linkText: 'www.damekellyholmestrust.org',
        featureFlagName: 'enableDameKellyHolmesCharity',
    },
    {
        value: OcdrCharity.RSPCA,
        imageUrl: 'images/charity-rspca.png',
        nameKey: 'charity.name.rspca',
        descriptionKey: 'charity.description.rspca',
        website: 'https://www.rspca.org.uk/',
        linkText: 'www.rspca.org.uk',
        featureFlagName: 'enableRSPCACharity',
    },
    {
        value: OcdrCharity.SAMARITANS,
        imageUrl: 'images/charity-samaritans.png',
        nameKey: 'charity.name.samaritans',
        descriptionKey: 'charity.description.samaritans',
        website: 'https://www.samaritans.org/',
        linkText: 'www.samaritans.org',
        featureFlagName: 'enableSamaritansCharity',
    },
    {
        value: OcdrCharity.CRUK,
        imageUrl: 'images/charity-cruk.png',
        nameKey: 'charity.name.cruk',
        descriptionKey: 'charity.description.cruk',
        website: 'https://www.cancerresearchuk.org/',
        linkText: 'www.cancerresearchuk.org',
        featureFlagName: 'enableCancerResearchCharity',
    },
    {
        value: OcdrCharity.GREAT_ORMOND_STREET,
        imageUrl: 'images/charity-great-ormond-street.png',
        nameKey: 'charity.name.great-ormond-street',
        descriptionKey: 'charity.description.great-ormond-street',
        website: 'https://www.gosh.org/',
        linkText: 'www.gosh.org',
        featureFlagName: 'enableGreatOrmondStreetCharity',
    },
    {
        value: OcdrCharity.NHS,
        imageUrl: 'images/charity-nhs.png',
        nameKey: 'charity.name.nhs',
        descriptionKey: 'charity.description.nhs',
        website: 'https://www.nhscharitiestogether.co.uk/what-we-do/',
        linkText: 'www.nhscharitiestogether.co.uk',
        featureFlagName: 'enableNhsCharity',
    },
    {
        value: OcdrCharity.DEC,
        imageUrl: 'images/charity-dec.png',
        nameKey: 'charity.name.dec',
        descriptionKey: 'charity.description.dec',
        website: 'https://www.dec.org.uk/',
        linkText: 'www.dec.org.uk',
        featureFlagName: 'enableDecCharity',
    },
];
